import React, { Component } from 'react'; 
import pdficon from './icon_pdf.png';
import { Table } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import { withTranslation } from 'react-i18next'
import { Cookies } from 'react-cookie';
import Customize from './Customize'

const cookies = new Cookies();
const constants = require('./constants');

class Signed extends Component {
    constructor(props) {
        super(props) //since we are extending class Table so we have to use super in order to override Component class constructor
        this.state = {
            docs: []
        }   
        this.parentEventSend = props.parentEventCb;
    }


    renderSigners(props) {
        const { t } = this.props;
        return props.map((signer) => {
            const { name, status, decision_date} = signer //destructuring

            var statusDate = ""
            if(status === 'SIGNED' || status === 'REJECTED' || status === 'EXPIRED' || status === 'ABORTED'){
                var date = this.renderDateTime(decision_date)
                if(status === 'SIGNED') {
                    statusDate = t("Signed") + ' (' + date + ' )' 
                }
                else if(status === 'REJECTED'){
                    statusDate = t("Rejected") + ' (' + date + ' )' 
                }
                else if(status === 'ABORTED') {
                    statusDate= t("Aborted") + ' (' + date + ' )' 
                }
                else {
                    statusDate = t("Expired") + ' (' + date + ' )' 
                }
            }

            return (
                <tr key={name}>
                    <td className="signersName">{name}</td>
                    <td className="signersStatus">{statusDate}</td>
                </tr>
            )
        });
    }

    renderAttachments(props) {
        return props.map((attachment, index) => {
            const { filename, udid } = attachment //destructuring
            
            return (
                <span key={udid}>
                        <img src={pdficon} alt="Fujitsu" height="20"></img><a href = {this.getAttachment(attachment.udid)} download={filename} target="_blank" rel="noopener noreferrer">{filename}</a> <br />
                </span>
            )
        });
    
    } 

    renderDateTime(props) {
        const { t } = this.props;
        return(
            new Intl.DateTimeFormat('fi', 
                                    {
                                        year: 'numeric', 
                                        month: 'numeric', 
                                        day: 'numeric', 
                                        hour: 'numeric', 
                                        minute: 'numeric', 
                                        second: 'numeric', 
                                        timeZoneName: 'short',
                                        hour12: false

                                    }).format(new Date(props)).replace("klo", t("TimeStampReplaceText"))
        )

    }
    renderDate(props) {
        const { t } = this.props;
        return(
            new Intl.DateTimeFormat('fi', 
                                    {
                                        year: 'numeric', 
                                        month: 'numeric', 
                                        day: 'numeric' 
                                    }).format(new Date(props)).replace("klo", t("TimeStampReplaceText"))
        )
    }

    getDocument = (row) => {
        if(row.doc_stat === 'CREATED') {
            var id = row.signDocId?row.signDocId:row.origDocId;
            return constants.GET_FILE_URL+"/api/getdocbyid/"+id;
        }
        return null;  // Doc removed
    }

    getAttachment = (id) => {
        return constants.GET_FILE_URL+"/api/getdocbyid/"+id;
    }

    checkFetchRespSession = (resp)=> {
        if (!resp.ok) {
          if(resp.status === 401) {
            this.parentEventSend("SESSION_EXPIRED");
          }
          throw Error(resp.statusText);
        }
        return resp;
      }

    localizeHeaderStatus(signStatus) {
        const { t } = this.props;

        if(signStatus  === 'SIGNED'){
            signStatus = t("Signed");
        } 
        else if(signStatus  === 'PARTIALLY_SIGNED'){
            signStatus = t("Partially Signed");
        }
        else {
            signStatus = t("Rejected");
        }
        return signStatus;
    }


   componentDidMount() {
    fetch(constants.SERVER_URL+"/api/signeddocs",{method:'get'})
    .then(resp => this.checkFetchRespSession(resp))
    .then(resp => {
        if (!resp.ok) {
            if(resp.status === 401) {
              cookies.remove('sessionToken', {path:"/"});
              sessionStorage.setItem('targetPage', constants.SERVER_CONTEXT_PATH+'/login');
            }
            throw Error(resp.statusText);
        }
        return resp;
      })    
    .then(resp =>resp.json())
    .then(data => this.setState({docs:data}))
    .catch(error => console.log("Fetching signeddocs error:", error));
    }

  render() {
    const { t } = this.props  
    return (
      <div>
        <Customize.Style />
        <p><br></br> </p>
        <h1 id='title'>{t("Signed Documents")}</h1>
        <BootstrapTable
            keyField='id'
            data={ this.state.docs.map(item => {
                item.formattedSignStatus = this.localizeHeaderStatus(item.signStatus);
                return item;
            })}
            columns={[
                    { dataField: 'docName',     text: t("Document Name")}, 
                    { dataField: 'reqDate',     text: t("Request Created"), formatter: dt => (<div>{this.renderDateTime(dt)}</div>)},   
                    { dataField: 'requestor',   text: t("Requested By")}, 
                    { dataField: 'formattedSignStatus',  text: t("Status")}, 
                    { dataField: 'signedDate',  text: t("Sign Date"), formatter: dt => (<div>{this.renderDate(dt)}</div>)} 
            ]}
            expandRow={{
                   renderer: row => (
                       <div className="container-fluid">
                           <Table className="table-sm">
                           <tbody className="expandTblRow">
                               <tr valign="top"><td></td>
                                   <td valign="top"><Table><tbody>
                                       <tr><td><b>{t("File Name")}: </b></td><td></td><td><img src={pdficon} alt="Fujitsu" height="20"></img><a href={this.getDocument(row)} download={row.fileName} target="_blank" rel="noopener noreferrer">{row.fileName}</a></td></tr>
                                       <tr><td><b>{t("Requested By")}: </b></td><td></td><td>{row.requestor}</td></tr>
                                       <tr><td><b>{t("Due Date")}: </b></td><td></td><td>{this.renderDate(row.dueDate)}</td></tr>
                                   </tbody>    
                                   </Table></td>
                                   <td></td>
                                   <td><Table className="table-sm">
                                       <thead>
                                           <tr><th style={{width: "50%"}}>{t("Signatures")}:</th><th style={{width: "50%"}}>{t("Status")}:</th></tr>
                                       </thead>
                                       <tbody>
                                       {this.renderSigners(row.signers)}
                                       </tbody>
                                   </Table></td>
                               </tr>
                               {row.attachments && row.attachments.length > 0? 
                                        <tr><td></td>
                                        <td>
                                            <Table className="table-sm">
                                                <tbody>
                                                <tr>
                                                <td style={{width: "27%"}}><b>{t("Attachments")}</b></td>
                                                <td>
                                                    {this.renderAttachments(row.attachments)}
                                                </td>
                                                
                                                </tr>
                                                </tbody>
                                            </Table>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>:null}
                           </tbody>    
                           </Table>
                       </div>
                   ), showExpandColumn: true,
                   
                   expandColumnRenderer: ({ expanded }) => {
                       if (expanded) {
                       return (
                           <b>{'\u25bc'}</b>
                       );
                       }
                       return (
                       <b>{'\u25ba'}</b>
                       );
                   },
                   
                   expandHeaderColumnRenderer: ({ isAnyExpands }) => {
                       if (isAnyExpands) {
                         return <b>{'\u25bc'}</b>;
                       }
                       return <b>{'\u25ba'}</b>;
                     }
            }}
            hover striped />      
      </div>
    );
  }
}

export default withTranslation()(Signed);




